/* Psolys · sign-up forms (not wired to Shopify yet). */
(() => {
  const { $, $$ } = window.psolys;
  $$('[data-form]').forEach(f => f.addEventListener('submit', e => {
    const st = $('[data-status]', f), email = f.querySelector('input[type=email]').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { e.preventDefault(); st.textContent = 'Vérifie ton adresse e-mail.'; f.querySelector('input[type=email]').focus(); return; }
    if (window.psolys.SHOPIFY) {
      /* Shopify saves the address as a customer who accepts marketing, with tags to tell the lists apart */
      const tags = f.querySelector('input[name="contact[tags]"]'), oil = f.querySelector('input[name=huile]');
      if (tags && oil && oil.checked && !/huile/.test(tags.value)) tags.value += ', huile';
      return;
    }
    e.preventDefault();
    st.textContent = 'Merci. Cette version de travail n’envoie encore rien\u00a0: l’inscription sera reliée à Shopify à la mise en ligne.';
  }));
})();
